import { Button } from '../components/Button';
import { PaneResizer } from './PaneResizer';

export interface InspectorElement {
  id: string;
  name: string;
  /** BPMN のローカル名（userTask・serviceTask …）。 */
  type: string;
}

export interface InspectorProps {
  element: InspectorElement | null;
  /** この要素をチャットの対象（文脈チップ）にする。 */
  onTarget(elementId: string): void;
  onClose(): void;
}

/**
 * 業務フローの右に置く詳細。S3 は名前・種類・対象にする操作だけ。
 * 名前や AI への指示の直接編集・出典のバッジ・未確定事項は残課題（C41）。
 */
export function Inspector({ element, onTarget, onClose }: InspectorProps) {
  return (
    <aside className="studio-inspector" aria-label="詳細">
      <PaneResizer pane="inspector" edge="start" label="詳細の幅" />
      {element === null ? (
        <p className="hint">Taskを選択して、内容や実装を確認</p>
      ) : (
        <div className="stack">
          <div className="studio-inspector-head">
            <span className="studio-inspector-type">{element.type}</span>
            <Button variant="text" aria-label="詳細を閉じる" onClick={onClose}>
              ×
            </Button>
          </div>
          <h3 className="studio-inspector-name">{element.name || element.id}</h3>
          <p className="hint">
            <code>{element.id}</code>
          </p>
          <div className="row">
            <Button onClick={() => onTarget(element.id)}>この要素を対象にする</Button>
          </div>
          <p className="hint">ファイルを直接直すときは「コード」の表示で保存します。保存すると利用者の変更として履歴に入り、AI の次のターンに伝わります。</p>
        </div>
      )}
    </aside>
  );
}
